import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import RadioGroup from '../../form/radio-group';
import SelectGroup from '../../form/select-group';
import _ from 'underscore';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        this.state = {
            packages: props.packages,
            pkg: props.packages[0],
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.checkout.type != this.props.checkout.type) {
            return true;
        }

        if (nextState.pkg != this.state.pkg) {
            return true;
        }

        return false;
    }

    render({ checkout, mode, product }, { pkg }) {
        if (checkout && checkout.order && !checkout.order.finalized) {
            if (_.contains(['standard', 'drt'], mode) && pkg) {
                return (
                    <options-kc mode={mode}>
                        <row className='is-justified-center'>
                            <column className='is-7 is-12-mobile'>
                                <row className='is-justified-center is-aligned-center'>
                                    <column className='is-1 is-2-mobile'>
                                        <RadioGroup
                                            name='checkout_option'
                                            checked={checkout.type == 'kc'}
                                            onChange={this.setPurchase}
                                        />
                                    </column>
                                    <column className='is-11 is-10-mobile'>
                                        <h4>
                                            {this.renderKCTotal(product)}
                                            <span className='has-padding-5-left'>Karma Coins</span>
                                            {this.renderBestOption()}
                                        </h4>
                                    </column>
                                </row>
                                {this.renderKCSelect()}
                            </column>
                        </row>
                    </options-kc>
                );
            }
        }

        return (<options-kc mode={mode} />);
    }

    setPurchase = () => {
        this.props.trackEvent([
            'Checkout',
            'LI Click',
            'Radio KC',
        ]);

        this.props.checkoutUpdate({
            type: 'kc',
            total: {
                current: this.state.pkg.usd.current,
                original: this.state.pkg.usd.original,
            },
        });
    }

    renderKCSelect = () => {
        if (
            this.state.packages
            &&
            (
                this.props.mode != 'drt'
                ||
                this.props.user.kcs.total < this.props.product.price.kc.current
            )
        ) {
            let options = {};
            this.state.packages.map(pkg => options[pkg.upc] = pkg.label);

            return (
                <row className='has-margin-30-top has-margin-15-bottom'>
                    <column className='is-12 has-text-size-13'>
                        <div className='has-margin-5-bottom'>
                            GET MORE READINGS — Choose a package below:
                        </div>
                        <SelectGroup
                            disabled={this.props.checkout.type != 'kc'}
                            name='package'
                            value={this.state.pkg.upc}
                            options={options}
                            onChange={this.selectKCPackage}
                        />
                    </column>
                </row>
            );
        }

        return null;
    }

    selectKCPackage = (e) => {
        this.props.trackEvent([
            'Checkout',
            'LI Click',
            'KC Dropdown',
        ]);

        const pkg = _.findWhere(this.state.packages, { upc: e.target.value });

        this.setState({ pkg: pkg });

        this.props.checkoutUpdate({
            type: 'kc',
            package: pkg,
            total: {
                current: pkg.usd.current,
                original: pkg.usd.original,
            },
        });
    }

    renderKCTotal = (product) => {
        if (product.price.kc.current != product.price.kc.original) {
            return [
                <span className='has-text-sushi has-text-size-32 has-weight-500'>
                    {product.price.kc.current}
                </span>,
                <span className='has-padding-10-left has-text-strikethrough'>
                    {product.price.kc.original}
                </span>,
            ];
        }

        return (product.price.kc.current);
    }

    renderBestOption = () => {
        if (!this.props.checkout || !this.props.checkout.drts) {
            return (
                <span className='has-padding-10-left has-text-tangerine has-text-size-12'>
                    <br className='is-visible-tiny' />
                    BEST OPTION!
                </span>
            );
        }

        return null;
    }
}

const mapStateToProps = (state) => ({
    checkout: state.checkout,
    packages: state.kc_packages,
    product: state.product,
    user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
    checkoutUpdate: (payload) => dispatch({
        type: 'checkout:update',
        payload: payload,
    }),
    trackEvent: (payload) => dispatch({
        type: 'ga:event',
        payload: payload,
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);